<template>
  <div class="listing-filters">
    <ul v-if="items" class="listing-filters__main-menu">
      <li
          v-for="(item, index) in items"
          :key="index"
          :class="{ 'listing-filters__item--active': activeFilter === getFilterCodename(item) }"
          class="listing-filters__item"
      >
        <button class="listing-filters__button btn--white" @click="triggerFilter(getFilterCodename(item))">
          <span class="listing-filters__button-title">{{ item.title }}</span>
          <span class="listing-filters__button-sub-title">{{ item.subtitle }}</span>
          <Arrow class="btn--arrow__icon btn--arrow__icon--bottom btn--arrow__icon--orange" />
        </button>
      </li>
    </ul>
    <div class="listing-filters__mobile-menu">
      <div class="row no-gutters">
        <button
            v-click-outside="away"
            :class="{ active: mobileMenuActive }"
            class="d-flex d-lg-none d-xl-none align-items-center justify-content-between listing-filters__toggle"
            aria-pressed="false"
            @click="toggleList"
        >
          <span class="listing-filters__toggle-text">{{ selectedTitle }}</span>
          <Chevron
              :class="{ 'listing-filters__icon--open': mobileMenuActive }"
              class="listing-filters__icon"
          />
        </button>
      </div>
      <div class="row no-gutters">
        <div class="listing-filters__list--wrapper">
          <ul :class="{ 'listing-filters__list--open': mobileMenuActive }" class="listing-filters__list">
            <li
                v-for="(item, index) in items"
                :key="index"
                :class="{ 'listing-filters__list-item--active': isActive(index) }"
                class="listing-filters__list-item col-lg-3"
            >
              <button
                  :class="{ disabled: disabled }"
                  class="listing-filters__trigger"
                  aria-pressed="false"
                  @click="updateSelected(index, item)"
              >
                {{ item.title }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { forceObject } from '~/utils/processor';

export default {
  props: {
    activeFilter: { type: String, default: '' },
    triggerFilter: { type: Function, required: true },
    items: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  data: function() {
    return {
      mobileMenuActive: false,
      selectedTitle: null,
      active: 0,
      disabled: false,
    };
  },
  watch: {
    active(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedTitle = this.items[newValue].title;
      }
    },
  },
  created() {
    if (this._props.items.length === 1) {
      this.disabled = true;
    }

    if (this._props.items.length > 0) {
      this.selectedTitle = this._props.items[0].title;
    }
  },
  methods: {
    getFilterCodename(item) {
      if (item.filter) {
        const { codename } = forceObject(item.filter);
        return codename;
      } else if (item.locationTaxonomy) {
        const { codename } = forceObject(item.locationTaxonomy);
        return codename;
      } else if (item.contentCodename) {
        return item.contentCodename;
      }
      return '';
    },
    away() {
      this.mobileMenuActive = false;
    },
    toggleList() {
      this.mobileMenuActive = !this.mobileMenuActive;
    },
    isActive(index) {
      return index === this.active;
    },
    updateSelected(index, item) {
      this.active = index;

      this.triggerFilter(this.getFilterCodename(item));
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_listing-filters.scss';
</style>
